/* Tech Craze product lightbox controls v2.8
   Keeps the route-safe Shopify product template intact while making the media modal behave like
   a controlled product lightbox: one slide visible, arrows do not close the modal, and images fit fully. */
(() => {
  const initLightbox = () => {
    document.querySelectorAll('product-modal.product-media-modal').forEach((modal) => {
      if (modal.dataset.tcLightboxEnhanced === 'true') return;

      const dialog = modal.querySelector('.product-media-modal__dialog');
      const content = modal.querySelector('.product-media-modal__content');
      if (!dialog || !content) return;

      modal.dataset.tcLightboxEnhanced = 'true';
      modal.classList.add('tc-lightbox-enhanced');

      const getSlides = () => Array.from(content.querySelectorAll('[data-media-id]'));

      // Dawn's media modal closes on pointerup anywhere that is not a media model/video wrapper.
      // Stop inside-dialog pointerup events so arrows and images do not close the modal.
      dialog.addEventListener('pointerup', (event) => {
        event.stopPropagation();
      }, true);

      dialog.addEventListener('click', (event) => {
        if (event.target.closest('.tc-product-lightbox-button, .tc-product-lightbox-counter, .product-media-modal__content')) {
          event.stopPropagation();
        }
      }, true);

      const makeButton = (direction) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = `tc-product-lightbox-button tc-product-lightbox-button--${direction}`;
        button.setAttribute('aria-label', direction === 'prev' ? 'View previous product image' : 'View next product image');
        button.innerHTML = direction === 'prev'
          ? '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M15.5 5.5 9 12l6.5 6.5" fill="none" stroke="currentColor" stroke-width="2.3" stroke-linecap="round" stroke-linejoin="round"/></svg>'
          : '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M8.5 5.5 15 12l-6.5 6.5" fill="none" stroke="currentColor" stroke-width="2.3" stroke-linecap="round" stroke-linejoin="round"/></svg>';
        button.addEventListener('pointerup', (event) => event.stopPropagation());
        button.addEventListener('click', (event) => event.stopPropagation());
        dialog.appendChild(button);
        return button;
      };

      const prevButton = makeButton('prev');
      const nextButton = makeButton('next');
      const counter = document.createElement('div');
      counter.className = 'tc-product-lightbox-counter';
      counter.setAttribute('aria-live', 'polite');
      dialog.appendChild(counter);

      let activeIndex = 0;

      const indexFromOpenedBy = () => {
        const slides = getSlides();
        const openedBy = modal.openedBy;
        const mediaId = openedBy && openedBy.getAttribute ? openedBy.getAttribute('data-media-id') : null;
        if (!mediaId) return -1;
        return slides.findIndex((slide) => slide.getAttribute('data-media-id') === mediaId);
      };

      const indexFromActiveClass = () => {
        const slides = getSlides();
        return slides.findIndex((slide) => slide.classList.contains('active'));
      };

      const setSlide = (index) => {
        const slides = getSlides();
        if (!slides.length) {
          prevButton.hidden = true;
          nextButton.hidden = true;
          counter.hidden = true;
          return;
        }

        activeIndex = Math.min(Math.max(index, 0), slides.length - 1);

        slides.forEach((slide, slideIndex) => {
          const isCurrent = slideIndex === activeIndex;
          slide.classList.toggle('tc-lightbox-current', isCurrent);
          slide.classList.toggle('active', isCurrent);
          slide.setAttribute('aria-hidden', isCurrent ? 'false' : 'true');
        });

        content.scrollLeft = 0;
        content.scrollTop = 0;

        prevButton.hidden = slides.length <= 1;
        nextButton.hidden = slides.length <= 1;
        counter.hidden = slides.length <= 1;
        prevButton.disabled = activeIndex === 0;
        nextButton.disabled = activeIndex === slides.length - 1;
        counter.textContent = `${activeIndex + 1} / ${slides.length}`;
      };

      const resolveStartIndex = () => {
        const fromOpenedBy = indexFromOpenedBy();
        if (fromOpenedBy >= 0) return fromOpenedBy;
        const fromActive = indexFromActiveClass();
        if (fromActive >= 0) return fromActive;
        return activeIndex || 0;
      };

      const goTo = (index) => {
        setSlide(index);
      };

      prevButton.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        goTo(activeIndex - 1);
      });

      nextButton.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        goTo(activeIndex + 1);
      });

      modal.addEventListener('keydown', (event) => {
        if (!modal.hasAttribute('open')) return;
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          goTo(activeIndex - 1);
        }
        if (event.key === 'ArrowRight') {
          event.preventDefault();
          goTo(activeIndex + 1);
        }
      });

      new MutationObserver(() => {
        if (modal.hasAttribute('open')) {
          window.setTimeout(() => setSlide(resolveStartIndex()), 40);
        }
      }).observe(modal, { attributes: true, attributeFilter: ['open'] });

      setSlide(0);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLightbox);
  } else {
    initLightbox();
  }
})();
